import React, { Component } from 'react'

import _ from 'lodash'

import { withTranslation } from 'react-i18next'
import { pageCommunicator } from '../../../communicators/pageCommunicator'

import { findNewsCategorySlug } from '../../../config/functions'

import { Page } from '../Page/Page'
import { PageInfo } from '../PageInfo/PageInfo'
import { AboutSection } from '../AboutSection/AboutSection'
import { SectionLinks } from '../SectionLinks/SectionLinks'
import { SectionsList } from '../SectionsList/SectionsList'
import { FeaturedNewsSection } from './FeaturedNewsSection'
import WebPageEvents from './WebPageEvents'
import './ukraineform-container.css'

class WebPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            page: null,
            isLoading: true,
            isUkrainaInfoPage: false,
            ukraineInfoKompanijaValue: '',
            ukraineInfoContactPerson: '',
            ukraineInfoMail: '',
            ukraineInfoContactPhone: '',
            ukraineInfoDescription: '',
            ukraineInfoFormSendingInProgres: false,
            ukraineInfoFormErrorMsgs: {},
            ukraineInfoFormSentSuccess: false
        }
    }

    componentDidMount() {
        this.loadPage()
    }

    componentDidUpdate(prevProps) {
        if (this.props.match.url !== prevProps.match.url) {
            this.setState({ page: null })
            this.loadPage()
        }
    }

    loadPage = async () => {
        try {
            const { slug } = this.props.match.params
            const page = await pageCommunicator.fetchPage(slug)

            this.setState({
                page,
                isLoading: false,
                isUkrainaInfoPage: slug === 'ukrajina-info-servis' ? true : false
            })
        } catch (error) {
            console.error(error)
            this.setState({ isLoading: false })
        }
    }

    depositKompanijaValue = data => {
        this.setState({
            ukraineInfoKompanijaValue: data
        })
    }

    depositContactPerson = data => {
        this.setState({
            ukraineInfoContactPerson: data
        })
    }
    depositMail = data => {
        this.setState({
            ukraineInfoMail: data
        })
    }

    depositContactPhone = data => {
        this.setState({
            ukraineInfoContactPhone: data
        })
    }

    depositDescription = data => {
        this.setState({
            ukraineInfoDescription: data
        })
    }

    startSending = () => {
        this.setState({
            ukraineInfoFormSendingInProgres: true
        })
        this.sendForm()
    }

    depositErrorsResponse = data => {
        if (data) {
            this.setState({
                ukraineInfoFormErrorMsgs: data
            })
        } else {
            this.setState({
                ukraineInfoFormErrorMsgs: {}
            })
        }
    }
    depositSentSuccess = data => {
        this.setState({
            ukraineInfoFormSentSuccess: data
        })
    }

    sendForm = () => {
        const formData = new FormData()

        formData.append('company', this.state.ukraineInfoKompanijaValue)
        formData.append('contact', this.state.ukraineInfoContactPerson)
        formData.append('email', this.state.ukraineInfoMail)
        formData.append('phone', this.state.ukraineInfoContactPhone)
        formData.append('details', this.state.ukraineInfoDescription)

        this.depositErrorsResponse({})
        fetch('https://api.pks.rs/public-api/ukraine/prijavi-problem', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Access-Control-Allow-Origin': '*'
            },
            body: formData
        })
            .then(res => res.json())
            .then(result => {
                result.success ? this.depositSentSuccess(true) : this.depositSentSuccess(false)
                this.depositErrorsResponse(result.errors)
                this.setState({
                    ukraineInfoFormSendingInProgres: false
                })
            })
            .catch(error => {
                this.setState({
                    ukraineInfoFormSendingInProgres: false
                })
            })
    }

    render() {
        const { page, isLoading, isUkrainaInfoPage } = this.state
        const { t } = this.props
        if (_.isEmpty(page)) {
            return <Page isLoading={isLoading} />
        }
        const { title, pageDescription } = page
        return (
            <Page
                isLoading={isLoading}
                title={`${t('headTitle')}/${title}`}
                description={pageDescription}
            >
                {page && (
                    <>
                        <PageInfo title={page.title} bgImage={page.headerImage} overlay />
                        {page.hasDescription && (
                            <AboutSection split={page.split} description={page.htmlDescription} />
                        )}
                        {page.news.map(({ id, name }) => {
                            const newsSectionTitle =
                                page.news.length > 1 ? name : t('webPage.newsSection.title')

                            const categorySlug = findNewsCategorySlug(id)

                            return (
                                <FeaturedNewsSection
                                    categoryId={id}
                                    title={newsSectionTitle}
                                    link={`/sve-vesti/kategorija/${id}/${categorySlug}`}
                                    key={id}
                                />
                            )
                        })}
                        {page.departments.length > 0 && (
                            <WebPageEvents departments={page.departments} />
                        )}
                        <SectionLinks title={page.sectionTitle} links={page.sectionLinks} dark />
                        <SectionsList sections={page.sections} />

                        {/* forma koja se pojavljuje samo na stranici veyanoj ya Ukrajina info page */}
                        {isUkrainaInfoPage && (
                            <section>
                                <div id="ukraine-form" className="section-container container-1280">
                                    <div className="top-section-title top-section-title--centered">
                                        <h3 className="top-section-title__text dark top-section-title__text--underlined">
                                            {t('ukraineForm.title')}
                                        </h3>
                                    </div>
                                    <div className="ukraineform-container">
                                        <div className="field-wrapper">
                                            <label
                                                className="regular-txt"
                                                htmlFor="naziv-primera-projektne-nastave"
                                            >
                                                {t('ukraineForm.company')}
                                            </label>
                                            <input
                                                className="regular-txt input-field"
                                                type="text"
                                                value={this.state.kompanijaValue}
                                                name="naziv-primera-projektne-nastave"
                                                onChange={e =>
                                                    this.depositKompanijaValue(
                                                        e.currentTarget.value
                                                    )
                                                }
                                            />
                                            <p className="regular-txt error-msg">
                                                {this.state.ukraineInfoFormErrorMsgs.company
                                                    ? t('ukraineForm.fieldRequired')
                                                    : ''}
                                            </p>
                                        </div>
                                        <div className="field-wrapper">
                                            <label
                                                className="regular-txt"
                                                htmlFor="naziv-primera-projektne-nastave"
                                            >
                                                {t('ukraineForm.contactPerson')}
                                            </label>
                                            <input
                                                className="regular-txt input-field"
                                                type="text"
                                                value={this.state.contactPerson}
                                                name="naziv-primera-projektne-nastave"
                                                onChange={e =>
                                                    this.depositContactPerson(e.currentTarget.value)
                                                }
                                            />
                                            <p className="regular-txt error-msg">
                                                {this.state.ukraineInfoFormErrorMsgs.contact
                                                    ? t('ukraineForm.fieldRequired')
                                                    : ''}
                                            </p>
                                        </div>
                                        <div className="field-wrapper">
                                            <label
                                                className="regular-txt"
                                                htmlFor="naziv-primera-projektne-nastave"
                                            >
                                                {t('ukraineForm.mail')}
                                            </label>
                                            <input
                                                className="regular-txt input-field"
                                                type="mail"
                                                value={this.state.mail}
                                                name="naziv-primera-projektne-nastave"
                                                onChange={e =>
                                                    this.depositMail(e.currentTarget.value)
                                                }
                                            />
                                            <p className="regular-txt error-msg">
                                                {this.state.ukraineInfoFormErrorMsgs.email
                                                    ? t('ukraineForm.fieldRequired')
                                                    : ''}
                                            </p>
                                        </div>
                                        <div className="field-wrapper">
                                            <label
                                                className="regular-txt"
                                                htmlFor="naziv-primera-projektne-nastave"
                                            >
                                                {t('ukraineForm.contactPhone')}
                                            </label>
                                            <input
                                                className="regular-txt input-field"
                                                type="phone"
                                                value={this.state.contactPhone}
                                                name="naziv-primera-projektne-nastave"
                                                onChange={e =>
                                                    this.depositContactPhone(e.currentTarget.value)
                                                }
                                            />
                                            <p className="regular-txt error-msg">
                                                {this.state.ukraineInfoFormErrorMsgs.phone
                                                    ? t('ukraineForm.fieldRequired')
                                                    : ''}
                                            </p>
                                        </div>

                                        <div className="field-wrapper">
                                            <label
                                                className="regular-txt"
                                                htmlFor="kratak-opis-primera-projektne-nastave"
                                            >
                                                {t('ukraineForm.description')}
                                            </label>
                                            <textarea
                                                className="regular-txt input-field"
                                                rows="6"
                                                type="text"
                                                value={this.state.ukraineInfoDescription}
                                                name="kratak-opis-primera-projektne-nastave"
                                                onChange={e =>
                                                    this.depositDescription(e.currentTarget.value)
                                                }
                                            />
                                            <p className="regular-txt error-msg">
                                                {this.state.ukraineInfoFormErrorMsgs.details
                                                    ? t('ukraineForm.fieldRequired')
                                                    : ''}
                                            </p>
                                        </div>

                                        {!this.state.ukraineInfoFormSendingInProgres && (
                                            <div
                                                className="send-button"
                                                onClick={this.startSending}
                                            >
                                                {t('ukraineForm.sendButton')}
                                            </div>
                                        )}
                                        {this.state.ukraineInfoFormSendingInProgres && (
                                            <div className="sendding-in-progress-button">
                                                {t('ukraineForm.sendingInProgressButton')}
                                            </div>
                                        )}
                                    </div>
                                </div>

                                {this.state.ukraineInfoFormSentSuccess && (
                                    <div className="sent-success-container">
                                        <p className="sent-succes-title">
                                            Uspešno ste prijavili problem.
                                        </p>

                                        <a
                                            className="sent-back-button"
                                            href="https://pks.rs/strana/ukrajina-info-servis"
                                        >
                                            Nazad na glavni sajt
                                        </a>
                                    </div>
                                )}
                            </section>
                        )}
                    </>
                )}
            </Page>
        )
    }
}

export default withTranslation()(WebPage)
